// Cookies (Use in rgpd, ...)
window.getCookie = (name) => {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));

  return match && match.length ? match[2] : null;
}
window.setCookie = (name, value, expires) => {
  // document.cookie = 'rgpd=approved; expires=Fri, 3 Aug 2020 20:47:11 UTC; path=/';
  var d = new Date();
  d = new Date((d.getTime() + 1000) * expires);
  document.cookie = name + '=' + value + '; expires=' + d.toGMTString() + '; path=/;SameSite=Lax;';
}

window.now = (() => {
  var d = new Date();
  var year = d.getFullYear();
  var month = ('0' + (d.getMonth() + 1)).slice(-2);
  var day = ('0' + d.getDate()).slice(-2);

  return year + '-' + month + '-' + day + ' ' + d.getHours() + ':' + d.getMinutes() + ':00';
})();

// To diff time between visit/registration/payment.
if (!getCookie('_first_now')) {
  if (now) {
    setCookie('_first_now', now, 2629800 * 13); // 2629800 = 1 month
    setCookie('_first_ua', encodeURIComponent(navigator.userAgent), 2629800 * 13);
    setCookie('_first_width', window.screen.width, 2629800 * 13);
    setCookie('_first_height', window.screen.height, 2629800 * 13);
    setCookie('_first_pixelDepth', window.screen.pixelDepth, 2629800 * 13);
    setCookie('_first_href', encodeURI(window.location.href).replace(/#.*/g, ''), 2629800 * 13);
    setCookie('_first_referer', encodeURI(document.referrer).replace(/#.*/g, ''), 2629800 * 13); // TODO What about the HTTPS redirect?
  }
}